// @ts-check

import { Trigger } from './Trigger'

/**
 * @typedef {Object} ClickTriggerOptions
 * @property {string} selector css selector of element to listen for clicks
 */

class ClickTrigger extends Trigger {
  clickHandler
  selector

  /**
   *
   * @param {ClickTriggerOptions} options
   */
  constructor({ selector }) {
    super()
    this.selector = selector

    this.clickHandler = () => this._dispatch()

    this._getSelectedNodes().forEach((item) => {
      item.addEventListener('click', this.clickHandler)
    })
  }

  /**
   * @returns {NodeListOf<Element>}
   */
  _getSelectedNodes() {
    return document.querySelectorAll(this.selector)
  }

  destroy() {
    this._getSelectedNodes().forEach((item) => {
      item.removeEventListener('click', this.clickHandler)
    })
    super.destroy()
  }
}

export { ClickTrigger }
